module.exports = __webpack_public_path__ + "eb091f503c1f246434d8a338f227ef35.svg";